import List from 'list.js';

export function exhibitors() {
  const list = document.querySelector('.archive-exhibitors');
  if(list) {
    const exhibitorsList = new List(list, {
      valueNames: [
        { name: 'booth', attr: 'data-name' },
        { name: 'number', attr: 'data-name' },
        { name: 'area', attr: 'data-name' },
        { name: 'name', attr: 'data-name' },
        'search-text'
      ]
    });

    const countEl = list.querySelector('.exhibitors-count');
    const updateCount = function() {
      if(countEl) {
        const visibleCount = exhibitorsList.visibleItems.length;
        countEl.textContent = fabfLabels.exhibitorsCount.replace('%d', visibleCount);
      }
    };

    exhibitorsList.on('searchComplete', updateCount);
    exhibitorsList.on('filterComplete', updateCount);

    exhibitorsList.sort('name', { order: "asc" });
    const nameSort = list.querySelector('.sort[data-sort="name"]');
    if(nameSort) nameSort.classList.add('asc');

    const normalize = function(str) {
      return (str || '').normalize('NFKC').toLowerCase();
    };

    const searchInput = list.querySelector('.search-input');
    if(searchInput) {
      searchInput.addEventListener('input', function() {
        const query = normalize(this.value.trim());
        if(!query) {
          exhibitorsList.filter();
          exhibitorsList.search();
          updateCount();
          return;
        }
        exhibitorsList.filter(function(item) {
          return normalize(item.values()['search-text']).indexOf(query) !== -1;
        });
        updateCount();
      });
    }

    // View toggle
    const viewToggles = list.querySelectorAll('.view-toggle');
    const listEl = list.querySelector('.list');
    const STORAGE_KEY = 'exhibitors-view';

    var setView = function(view) {
      listEl.classList.remove('view-list', 'view-grid');
      listEl.classList.add('view-' + view);
      viewToggles.forEach(function(t) {
        t.classList.toggle('active', t.dataset.view === view);
      });
      try { localStorage.setItem(STORAGE_KEY, view); } catch(e) {}
    };

    viewToggles.forEach(function(toggle) {
      toggle.addEventListener('click', function() {
        setView(this.dataset.view);
      });
    });
  }
}